import { render, staticRenderFns } from "./memberPower.vue?vue&type=template&id=cca0d048&scoped=true"
import script from "./memberPower.vue?vue&type=script&lang=js"
export * from "./memberPower.vue?vue&type=script&lang=js"
import style0 from "./memberPower.vue?vue&type=style&index=0&id=cca0d048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca0d048",
  null
  
)

export default component.exports